<template>
  <div class="dev-tools-wrapper">
    <div class="custom-wrapper">
      <el-form
        label-position="top"
        ref="logForm"
        style="width: 60%; margin: 0 auto;"
        :rules="formRules"
        :model="form">

        <el-form-item label="日期" prop="userid">
          <el-date-picker
            v-model="form.date"
            type="date"
            placeholder="选择日期"
            value-format="yyyyMMdd"
            style="width: 100%">
          </el-date-picker>
        </el-form-item>

        <el-form-item style="display: flex; justify-content: center;">
          <el-button :loading="loading" type="danger" @click="onSubmit">下载</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import userApi from '@/api/userApi'
import moment from 'moment'

export default {
  name: 'CloudLog',
  data () {
    return {
      loading: false,
      form: {
        date: moment().format('YYYYMMDD')
      },
      formRules: {
        date: [
          { required: true, message: '请选择下载的日志日期', trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    onSubmit () {
      if (this.loading) return

      this.$refs['logForm'].validate(async valid => {
        if (!valid) {
          return false
        }

        this.loading = true

        const res = await userApi.getCloudLog(this.form.date)
        const blob = new Blob([res], { type: 'application/zip' })
        const link = document.createElement('a')
        link.style.display = 'none'
        link.setAttribute('download', `amk.business.backend-web.${this.form.date}.log.zip`)
        link.setAttribute('href', URL.createObjectURL(blob))
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(link.href)

        this.loading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/sass/base";

.dev-tools-wrapper {
  h3 {
    color: $primaryColor;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/op/CloudLog.vue